jQuery(document).ready(function ($) {
  function showMessage(form, message, isSuccess = true) {
    const msgHtml = `<div class="alert ${isSuccess ? 'alert-success' : 'alert-danger'} mt-4">${message}</div>`;
    form.append(msgHtml);
    setTimeout(() => form.find('.alert').fadeOut(), 4000);
  }

  function submitCertificateForm(formId) {
    const form = $(formId);
    const data = {
      certificate_name: form.find('input[name="certificate_name"]').val(),
      term_name: form.find('input[name="term_name"]').val(),
      abbreviation: form.find('input[name="abbreviation"]').val() || '',
    };

    $.ajax({
      url: certificateslist_ajax.rest_url,
      method: 'POST',
      beforeSend: function (xhr) {
        xhr.setRequestHeader('X-WP-Nonce', certificateslist_ajax.nonce);
      },
      contentType: 'application/json',
      data: JSON.stringify(data),
      success: function (response) {
        showMessage(form, 'Certificate added successfully!', true);
        form.data('dirty', false);
        checkForms();
        form.trigger('reset');
      },
      error: function (xhr) {
        const error = xhr.responseJSON?.error || 'Something went wrong.';
        showMessage(form, error, false);
      },
    });
  }

  $('#addCertificateForm').on('submit', function (e) {
    e.preventDefault();
    submitCertificateForm('#addCertificateForm');
  });

  $('#addSpecialistCertificateForm').on('submit', function (e) {
    e.preventDefault();
    submitCertificateForm('#addSpecialistCertificateForm');
  });

  // Handle certificate toggle changes
  $('.certificates-toggle').on('toggleChanged', function (event, data) {
    const $toggle = $(this);
    const certificateId = $toggle.data('id');
    const status = data.isActive ? 'on' : 'off';

    if (!certificateId) {
      // console.error('Certificate ID not available for toggle update.');
      return;
    }

    $.ajax({
      url: certificateslist_ajax.rest_url + '/' + certificateId + '/status',
      method: 'POST',
      beforeSend: function (xhr) {
        xhr.setRequestHeader('X-WP-Nonce', certificateslist_ajax.nonce);
      },
      contentType: 'application/json',
      data: JSON.stringify({ status: status }),
      success: function (response) {
        // Optionally update the toggle state visually if needed
        // $toggle.prop('checked', data.isActive); // Adjust based on your toggle implementation
        showMessage($('body'), 'Certificate status updated successfully.', true);
        console.log('Certificate status updated successfully.')
      },
      error: function (xhr) {
        $toggle.trigger('toggleChanged', { isActive: !data.isActive }); // Revert toggle if failed
        showMessage($('body'), 'Failed to update certificate status.', false);
      },
    });
  });
});
